import { sparql } from '@tpluscode/rdf-string';
import { select } from "./execute.mjs";
import WHERE from "./partials/WHERE.mjs";
import LIMIT from "./partials/LIMIT.mjs";
import ORDER from "./partials/ORDER.mjs";
import FROM from "./partials/FROM.mjs";
import GROUP from "./partials/GROUP.mjs";
import HAVING from "./partials/HAVING.mjs";
import Builder from "./index.mjs";

const SelectBuilder = (strings, ...values) => ({ ...Builder(),
  ...select,
  ...WHERE({
    required: true
  }),
  ...LIMIT(),
  ...ORDER(),
  ...GROUP(),
  ...HAVING(),
  ...FROM(),
  distinct: false,
  reduced: false,
  variables: sparql(strings, ...values),

  _getTemplateResult() {
    const modifier = this.distinct ? 'DISTINCT ' : this.reduced ? 'REDUCED ' : '';
    return sparql`SELECT ${modifier}${this.variables}
${this.fromClause()}
${this.whereClause()}
${this.orderClause()}
${this.groupByClause()}
${this.havingClause()}
${this.limitOffsetClause()}`;
  }

});

SelectBuilder.DISTINCT = (strings, ...values) => ({ ...SelectBuilder(strings, ...values),
  distinct: true
});

SelectBuilder.REDUCED = (strings, ...values) => ({ ...SelectBuilder(strings, ...values),
  reduced: true
});

Object.defineProperty(SelectBuilder, 'ALL', {
  get() {
    return SelectBuilder`*`;
  }

});
export const SELECT = SelectBuilder;